// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonBoolean = {
  yes: "是",
  no: "否",
} as const;
